import Choices from 'choices.js'

export default function choices() {
  const items = Array.from(document.querySelectorAll('[data-choices-select'))

  items.forEach(item => {
    new Choices(item, {
      searchEnabled: false,
      shouldSort: false
    })
  })

}